import React from "react";
import "./CustomRadioButtonStyle.css";

const CustomRadioButton = ({
  name,
  value,
  text,
  className,
  onChange,
  checked,
  label,
  disabled,
}) => {
  return (
    <div className={`radioWrap ${className}`}>
      <label className="labelWrap">
         
        <input
          onChange={onChange}
          type="radio"
          name={name}
          value={value}
          checked={checked}
          disabled={disabled}
        />
        <span className="radioText">{label}</span>
        <span className="checkmark"></span>
      </label>
    </div>
  );
};

export default CustomRadioButton;
